import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { WebsiteItem } from '@/types';
    import { ref, PropType, computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MailToQuotes',
  props: {
        product: { type: Object as PropType<WebsiteItem|undefined>, required: false }
    },
  setup(__props) {

const props = __props

    

    const subject = ref<string>('')
    const body = ref<string>('')

    const email = computed(() => {
        let output = ''
        if(props.product) {
            output += `?subject=Quote Request: ${props.product.name}`
            output += "&body="
            output += addProductSelections(props.product)
        }    
        return output    
    })

    function addProductSelections(selections: WebsiteItem) {
        let html = "MESSAGE:%0D%0A%0D%0A%0D%0A"
        Object.keys(product_selections).forEach(key => {
            if(key in selections) {
                html += `${product_selections[key]}: ${(selections as any)[key].replace('&','and')}%0D%0A`
            }
        })
        html += "%0D%0ASELECTIONS:%0D%0A"
        Object.keys(attribute_selections).forEach(key => {
            if(key in selections) {
                html += `${attribute_selections[key]}: ${(selections as any)[key].replace('&','and')}%0D%0A`
            }
        })

        return html
    }

    const product_selections: Record<string,string> = {
        name: 'Name',
        base_door_text: 'Base Door',
        url: 'Product Page',
        imageUrl: 'Image Link'
    }

    const attribute_selections: Record<string,string> = {
        material_text: "Material",
        glass_text: "Glass",
        thickness_text: "Thickness",
        height_text: "Height",
        width_text: "Width",
        door_profile_text: "Door Profile",
        door_panel_type_text: "Panel Type",
        door_panel_adder_text: "Panel Adder",
        louver_profile_text: "Louver Profile",
        series_text: "Series",
        edge_text: "Edge",
        core_text: "Core",
        stile_text: "Stile",
        stick_text: "Stick",
        unit_option_text: "Unit Option",
        insulating_type_text: "Insulating Type",
        track_type_text: "Track Type",
        track_color_text: "Track Color",
        track_size_text: "Track Size"
    }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: `mailto:quotes@woodportdoors.com${_unref(email)}`
  }, "quotes@woodportdoors.com", 8, _hoisted_1))
}
}

})